var render = function render(){var _vm=this,_c=_vm._self._c;return _c('focus-lock',[_c('div',{staticClass:"modal-container"},[_c('button',{staticClass:"modal-close",attrs:{"role":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{staticClass:"icon icon-close"})]),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }